import React, { useEffect, useRef } from 'react'
import { ClientsTab } from '@/components/clients/ClientsTab'
import { useAttachedClientsStore } from '@/stores/attached-clients.store'
import { useGroupsStore } from '@/stores/groups.store'

export const AttachedClientsPage: React.FC = () => {
  const fetchAttachedClients = useAttachedClientsStore(state => state.fetchAttachedClients)
  const fetchGroups = useGroupsStore(state => state.fetchGroups)
  const hasFetchedRef = useRef(false)

  useEffect(() => {
    if (hasFetchedRef.current) return
    hasFetchedRef.current = true

    Promise.all([fetchAttachedClients(), fetchGroups()]).catch(error => {
      console.error('Error loading data:', error)
    })
  }, [fetchAttachedClients, fetchGroups])

  return <ClientsTab mode="attached" />
}
